import { fromJS } from "immutable";

// Action types
export const SET_LABEL_OPTION = 'SET_LABEL_OPTION';
export const SET_ALL_LABEL_OPTIONS = 'SET_ALL_LABEL_OPTIONS';

// Initial state
export const initialLabelState = fromJS({
  product_name: true,
  product_sku: true,
  product_color: false,
  product_wprice: false,
  product_rprice: false,
  product_sizes: false
});

// Action creators
export const setLabelOption = (optionId, value) => ({
  type: SET_LABEL_OPTION,
  payload: { optionId, value }
});

export const setAllLabelOptions = (options) => ({
  type: SET_ALL_LABEL_OPTIONS,
  payload: options
});

// Reducer
export function labelReducer(state = initialLabelState, action) {
  switch (action.type) {
    case SET_LABEL_OPTION:
      return state.set(action.payload.optionId, action.payload.value);
    case SET_ALL_LABEL_OPTIONS:
      return state.merge(action.payload);
    default:
      return state;
  }
}